import qFetch from '@/utils/qFetch'

export function fetchCommodity(params) {
  const url = '/bnbbingo/app/tyinggoodssale/queryinfo'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: {
      parameter: {
        productIds: params
      }
    },
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function createOrder(params) {
  const url = '/bnbbingo/app/tyinggoodssale/createorder'
  return qFetch({
    url: '/tjbnb/app/common/login',
    data: {
      parameter: params

    },
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function getToken(params) {
  return qFetch({
    url: '/tjbnb/app/paymentorder/create',
    data: params
  }).then((res) => {
    return Promise.resolve(res)
  }).catch(() => {
    return Promise.reject(new Error('网络异常，稍后再试'))
  })
}
